import { Dispatch } from "redux/commonTypes";

import bonusApi from "./bonusApi";
import { actionTypes, bonusType } from "./bonusTypes";
import purchaseActions from "redux/ducks/purchase/purchaseActions";


const Actions = {
  setBonusUsed: (bonus: boolean) => ({
    type: actionTypes.SET_FILL_BONUS_AVAILABLE,
    payload: bonus
  }),
  setBonusData: (bonusData: Array<bonusType>) => ({
    type: actionTypes.SET_BONUS_DATA,
    payload: bonusData
  }),
  setBonusPercent: (percent: number) => ({
    type: actionTypes.SET_FILL_BONUS_PERCENT,
    payload: percent
  }),
  setShowConragts: (show: boolean) => ({
    type: actionTypes.SET_SHOW_CONGRATS,
    payload: show
  }),
  setBonusEditModalOpened: (open: boolean) => ({
    type: actionTypes.SET_BONUS_EDIT_MODAL_OPENED,
    payload: open
  }),
  // После успешного получения подарка: флаги/баланс/профиль.
  applyBonusClaimed: () => (dispatch: Dispatch) => {
    dispatch(Actions.setBonusUsed(true));
    dispatch(Actions.setBonusData([]));
    (dispatch as any)(purchaseActions.getBalance());
    // Avoid circular import with profileActions
    import("redux/ducks/profile/profileActions").then((mod) => {
      (dispatch as any)(mod.default.getExtendedProfileInfo(true));
    });
  },
  // deferred: вызывающий (подарочный пэйвол) сам показывает congrats поверх
  // себя и применяет результат (applyBonusClaimed) после закрытия попапа —
  // иначе bonusUsed=true сразу размонтировал бы пэйвол вместе с попапом.
  // Возвращает Promise<boolean> (успех).
  useBonus: (opts?: { deferred?: boolean }) => (dispatch: Dispatch): Promise<boolean> => {
    return bonusApi
      .useBonus()
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          if (!opts?.deferred) {
            setTimeout(() => {
              dispatch(Actions.setShowConragts(true));
              (dispatch as any)(Actions.applyBonusClaimed());
            }, 100);
          }
          return true;
        }
        return false;
      })
      .catch(() => false);
  }
};
  
export default Actions;
